// extracted by mini-css-extract-plugin
export default {"sizeMD":"16px","attributesLineHeight":"1.8","icon":"G5284d8","description":"G279f13 Ga59eac G4e1407 G81a5ae","attribute":"Gcc0800"};